export function addExtraInfoComponents(value, controller) {
  const newItems = controller.options.filter(item => {
    return value.indexOf(item.key) === -1;
  });
  if (newItems.length === 0) {
    return value;
  }
  const valueArray = value.split(',');
  newItems.forEach(item => {
    if (item.defaultSection === 'top') {
      const middleIndex = valueArray.findIndex(orderItem => orderItem === 'middle');
      valueArray.splice(middleIndex, 0, item.key);
    } else if (item.defaultSection === 'middle') {
      const bottomIndex = valueArray.findIndex(orderItem => orderItem === 'bottom');
      valueArray.splice(bottomIndex, 0, item.key);
    } else {
      valueArray.push(item.key);
    }
  });
  return valueArray.join(',');
}
//# sourceMappingURL=infoUtils.js.map